import type { DomainGenerationMode, CreativityLevel } from '~/types/domain';
import type { Tld } from '~/config/tld-config';
import { DEFAULT_TLDS } from '~/config/tld-config';

export interface SearchSettings {
  mode: DomainGenerationMode;
  maxLength: number;
  selectedTlds: Tld[];
  creativityLevel: CreativityLevel;
  tldMode: 'auto' | 'explicit';
  domainLanguage: string;
  avoidExpensiveTlds: boolean;
}

// Constant for UI display - how many results to show initially/load more
export const MAX_DOMAINS_TO_LOAD = 50;

export const DEFAULT_SETTINGS: SearchSettings = {
  mode: 'brandable',
  maxLength: 20,
  selectedTlds: [...DEFAULT_TLDS],
  creativityLevel: 'balanced',
  tldMode: 'auto',
  domainLanguage: '',
  avoidExpensiveTlds: true,
};

// Helper function to check if settings are default
export const isDefaultSettings = (settings: SearchSettings): boolean => {
  return (
    settings.mode === DEFAULT_SETTINGS.mode &&
    settings.maxLength === DEFAULT_SETTINGS.maxLength &&
    JSON.stringify([...settings.selectedTlds].sort()) ===
      JSON.stringify([...DEFAULT_SETTINGS.selectedTlds].sort()) &&
    settings.creativityLevel === DEFAULT_SETTINGS.creativityLevel &&
    settings.tldMode === DEFAULT_SETTINGS.tldMode &&
    settings.domainLanguage === DEFAULT_SETTINGS.domainLanguage &&
    settings.avoidExpensiveTlds === DEFAULT_SETTINGS.avoidExpensiveTlds
  );
};
